import API from './API.ts'

export default {
  getAccommodationCharges ({ checkIn, checkOut, cancellationPolicyId, categoryId, adults, children, dogs, isApplyBookingFee, isApplyPositionReservationFee, isApplyElectricityFee }) {
    return API.httpClient.get('rates/accommodation-charges', {
      params: {
        check_in: checkIn.format('YYYY-MM-DD'),
        check_out: checkOut.format('YYYY-MM-DD'),
        cancellation_policy_id: cancellationPolicyId,
        category_id: categoryId,
        adults,
        children,
        dogs,
        is_apply_booking_fee: isApplyBookingFee,
        is_apply_position_reservation_fee: isApplyPositionReservationFee,
        is_apply_electricity_fee: isApplyElectricityFee
      }
    })
  },
  getBookingGroupAccommodationCharges ({ bookingGroup }) {
    const checkIn = bookingGroup.checkIn.format('YYYY-MM-DD')
    const checkOut = bookingGroup.checkOut.format('YYYY-MM-DD')
    const cancellationPolicyId = bookingGroup.cancellationPolicy?.id
    const sameCancellationPolicyForAllBookings = bookingGroup.sameCancellationPolicyForAllBookings
    const bookingGroupAppliedFees = bookingGroup.appliedFees

    const bookings = bookingGroup.bookings.map((booking) => {
      return {
        category_id: booking.category.id,
        check_in: booking.checkIn.format('YYYY-MM-DD'),
        check_out: booking.checkOut.format('YYYY-MM-DD'),
        adults: booking.adults,
        children: booking.children,
        dogs: booking.dogs,
        cancellation_policy_id: booking.cancellationPolicy?.id,
        applied_fees: booking.appliedFees
      }
    })

    return API.httpClient.get('rates/booking-group-accommodation-charges', {
      params: {
        check_in: checkIn,
        check_out: checkOut,
        cancellation_policy_id: cancellationPolicyId,
        same_cancellation_policy_for_all_bookings: sameCancellationPolicyForAllBookings,
        booking_group_applied_fees: bookingGroupAppliedFees,
        bookings
      }
    })
  },
  getRebookingPreview ({ bookingId, checkIn, checkOut, cancellationPolicyId, categoryId, adults, children, dogs, isApplyBookingFee, isApplyPositionReservationFee, isApplyElectricityFee }) {
    return API.httpClient.get('rates/rebooking-charges', {
      params: {
        booking_id: bookingId,
        check_in: checkIn.format('YYYY-MM-DD'),
        check_out: checkOut.format('YYYY-MM-DD'),
        cancellation_policy_id: cancellationPolicyId,
        category_id: categoryId,
        adults,
        children,
        dogs,
        is_apply_booking_fee: isApplyBookingFee,
        is_apply_position_reservation_fee: isApplyPositionReservationFee,
        is_apply_electricity_fee: isApplyElectricityFee
      }
    })
  },
  getPrice ({ positionId, checkInDate, checkOutDate }) {
    return API.httpClient.get('rates/get-price', {
      params: {
        position_id: positionId,
        check_in_date: checkInDate.format('YYYY-MM-DD'),
        check_out_date: checkOutDate.format('YYYY-MM-DD')
      }
    })
  }
}
